import React from 'react';
import NavBar from '../NavBar/NavBar';
import { useTranslation } from 'react-i18next';
import Footer from '../Footer/Footer';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <NavBar/>
      {
        i18n.language === 'ar' 
        ?
    
            <div className="max-w-4xl mx-auto p-6 text-gray-800 leading-relaxed">
              
              {/* HEADER */}
              <header className="mb-6">
                <h1 className="text-3xl font-bold text-main mb-3">سياسة الخصوصية</h1>
                <p>
                  سياسة الخصوصية لدينا توضح كيفية جمعنا وحفظنا واستخدامنا وحمايتنا لمعلوماتك الشخصية، 
                  والمقصود بالمعلومات الشخصية هي تلك التي ترتبط بشخص معين وتُستخدم للتعريف عنه.
                </p>
              </header>
        
              {/* SECTION 1 */}
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-main mb-2">مقدمة</h2>
                <p className="mb-3">
                  نقوم بجمع المعلومات الشخصية من الراغبين باستخدام موقع جراندي هوم أو الصفحات المرتبطة به. 
                  وبمجرد تزويدك لنا بمعلوماتك الشخصية، تكون قد فوّضتنا بمعالجة هذه المعلومات وفقًا لسياسة الخصوصية.
                </p>
                <p className="mb-3">
                  قد نقوم بتعديل سياسة الخصوصية في أي وقت من خلال نشر النسخة المعدلة على الموقع، 
                  ويُعتبر استمرارك في استخدام الموقع موافقة منك على الشروط الجديدة.
                </p>
                <p className="note bg-blue-50 p-4 rounded-lg border-r-4 border-blue-300">
                  نوصيك بزيارة هذه الصفحة من وقت لآخر لمعرفة أي تحديثات على سياسة الخصوصية.
                </p>
              </section>
        
              {/* SECTION 2 */}
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-main mb-3">جمع معلوماتك الشخصية</h2>
        
                <p className="mb-3">
                  عند التسجيل أو استخدام الموقع قد يُطلب منك تزويدنا بمعلومات مثل:
                </p>
        
                <ul className="list-disc mr-6 mb-4 space-y-1">
                  <li>اسمك</li>
                  <li>عنوان الشحن</li>
                  <li>البريد الإلكتروني</li>
                  <li>رقم الهاتف</li>
                  <li>تاريخ الميلاد</li>
                  <li>بيانات مالية مثل بطاقة الائتمان أو الحساب البنكي</li>
                </ul>
        
                <p className="mb-3">
                  يجب إدخال البيانات المالية فقط في صفحة "حسابي" أو أثناء إتمام الطلب لحمايتك من الاحتيال.
                </p>
        
                <p className="mb-3">
                  قد نجمع أيضًا معلومات تقنية مثل:
                </p>
        
                <ul className="list-disc mr-6 mb-6 space-y-1">
                  <li>عنوان IP</li>
                  <li>نوع المتصفح</li>
                  <li>الصفحات التي تزورها</li>
                  <li>عدد مرات استخدامك للموقع</li>
                </ul>
        
                <p>
                  قد نجمع أيضًا المعلومات التي تقدمها أثناء تواصلك مع الدعم الفني أو من خلال الاستبيانات، 
                  ويتم استخدامها لأغراض إحصائية دون إظهار هويتك.
                </p>
              </section>
        
              {/* SECTION 3 */}
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-main mb-3">استخدام معلوماتك الشخصية</h2>
        
                <p className="mb-3">
                  نستخدم معلوماتك لتقديم الخدمات، تحسين الأداء، منع النشاطات غير القانونية، تنفيذ شروط الاستخدام،
                  التواصل معك، إصدار الفواتير، والتحقق من عمليات الدفع.
                </p>
        
                <p className="mb-3">
                  قد نشارك معلوماتك مع أطراف مثل:
                </p>
        
                <ul className="list-disc mr-6 mb-4 space-y-1">
                  <li>البنوك</li>
                  <li>شركات بطاقات الائتمان</li>
                  <li>شركات الشحن (الاسم – العنوان – رقم الهاتف)</li>
                </ul>
        
                <p className="mb-3">
                  قد نُفصح عن بياناتك لجهات قانونية أو حكومية عندما يُطلب منا ذلك قانونيًا أو لمنع ضرر محتمل.
                </p>
        
                <p className="mb-3">
                  نحن لا نبيع أو نؤجر معلوماتك لأي طرف ثالث خارج إطار سياسة الخصوصية.
                </p>
        
                <p>
                  عند استخدامك للموقع فأنت توافق على تلقي رسائل ترويجية ويمكنك إلغاء الاشتراك بسهولة من الرابط الموجود أسفل الرسائل.
                </p>
              </section>
        
              {/* SECTION 4 */}
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-main mb-3">
                  إدارة وتعديل معلوماتك الشخصية
                </h2>
        
                <p className="mb-3">
                  يمكنك الوصول وتعديل بياناتك عبر صفحة "حسابي". وفي حال تغيّرت بياناتك يجب تحديثها فورًا.
                </p>
        
                <p>
                  نحتفظ بمعلوماتك حسب ما يقتضيه القانون لمنع الاحتيال ودعم التحقيقات.
                </p>
              </section>
        
              {/* SECTION 5 */}
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-main mb-3">
                  ملفات تعريف الارتباط (Cookies)
                </h2>
        
                <p className="mb-3">
                  يستخدم موقعنا ملفات تعريف الارتباط لتحسين تجربتك، وهي لا تكشف أي معلومات شخصية.
                </p>
        
                <p>
                  يمكنك تعطيلها من إعدادات المتصفح دون التأثير على تجربة الاستخدام.
                </p>
              </section>
        
              {/* SECTION 6 */}
              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-main mb-3">حماية معلوماتك الشخصية</h2>
        
                <p className="mb-3">
                  نتخذ إجراءات صارمة لحماية معلوماتك من الوصول غير المصرح به، وتُشفّر كافة البيانات الشخصية.
                </p>
        
                <p className="mb-3">
                  يجب استخدام كلمة سر قوية وعدم مشاركتها مع أي أحد. إذا شعرت بأن بياناتك تعرضت للاختراق، 
                  تواصل مع خدمة العملاء فورًا وقم بتغيير كلمة المرور من صفحة "حسابي".
                </p>
              </section>
        
            </div>
        :
        
      <div className="max-w-4xl mx-auto p-6 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold text-main mb-6">{t('Privacy Policy')}</h1>

      <p className="mb-4">
        {t("This Privacy Policy sets out the policy of")}{" "}
        <span className="font-semibold text-red-800">( JOBA ACADEMY )</span> with respect to the way we obtain,
        use, and disclose information about you through this website.
      </p>

      <p className="mb-6">
        We understand and appreciate that you are concerned about privacy, particularly in relation to the use
        and disclosure of personal information. We are committed to providing a high level of privacy in
        relation to all personal information that is collected by us. The purpose of this Privacy Policy is to
        tell you what kind of information we may gather about you when you visit our site, how we may use that
        information, whether we disclose it to anyone, and the choices you have regarding how we will use your
        personal information, and your ability to correct this information.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">YOUR CONSENT</h2>
      <p className="mb-6">
        You consent to your personal information being used in accordance with this privacy policy by visiting
        our website, entering a competition on our website, purchasing our products, and/or providing us with
        your personal information on the website.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">COLLECTION OF INFORMATION</h2>
      <p className="mb-6">
        Information is collected from you primarily to make it easier and more rewarding for you to use our
        website and services. Depending on the service you are accessing, you could be asked to provide
        information such as your name, email address, or preferences. It is entirely your choice whether to
        respond or not.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">USE OF PERSONAL INFORMATION</h2>
      <p className="mb-4">
        <span className="font-semibold text-red-800">( JOBA ACADEMY )</span> will use the personal information
        you have chosen to provide for the purpose for which it was provided. We will not use it for any other
        purpose without your consent.
      </p>
      <p className="mb-6">
        We may occasionally use this information to notify you of important changes to our website or special
        promotions. Every communication will include simple instructions on how to unsubscribe. You can opt out
        any time by emailing our privacy manager. All information we collect will be treated with strict
        confidentiality.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">DISCLOSURE</h2>
      <p className="mb-4">
        There may be occasions where it is necessary for{" "}
        <span className="font-semibold text-red-800">( JOBA ACADEMY )</span> to disclose your personal
        information to third parties—for example, to process billing or deliver products you purchased.
      </p>
      <p className="mb-6">
        No information will be disclosed unless required to fulfill the service you requested or if required by
        law enforcement in relation to suspected breaches of the law.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">NO SALE OF PERSONAL INFORMATION</h2>
      <p className="mb-6">
        Under no circumstances will{" "}
        <span className="font-semibold text-red-800">( JOBA ACADEMY )</span> sell or receive payment for
        disclosing your personal information.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">PASSWORDS</h2>
      <p className="mb-6">
        You are solely responsible for maintaining the secrecy of your passwords and personal information. Be
        responsible whenever you are online.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">CREDIT CARDS</h2>
      <p className="mb-6">
        We do not store credit card information. Payments are managed through secure facilities using updated
        SSL encryption systems.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">SECURITY</h2>
      <p className="mb-4">
        <span className="font-semibold text-red-800">( JOBA ACADEMY )</span> operates secure data networks
        designed to protect your privacy. However, we remind you that no online transmission is completely
        secure and we accept no responsibility for information transmitted via unsecured internet connections.
      </p>
      <p className="mb-6">
        We are not liable for loss or damage arising from unauthorized access to your personal information,
        whether caused by negligence, willful misconduct, or otherwise.
      </p>

      <h2 className="text-2xl font-semibold text-main mb-2">ACCESS AND CORRECTION</h2>
      <p className="mb-4">
        We make reasonable efforts to ensure your information is stored securely. You may request access to the
        information we hold about you at any time.
      </p>
      <p className="mb-6">
        If you find any errors, notify us and we will update or correct the information. We aim to keep all
        personal data accurate, complete, and up to date.
      </p>
    </div>
  }
  <Footer/>
  </div>
  );
}

export default PrivacyPolicy;

